import { Layers } from "appworks/graphics/layers/layers";
import { AutoSpinsCountRadioControlFactory } from "appworks/ui/factories/autoplay/auto-spins-count-radio-control-factory";
import { AgsAutoSpinsCountRadioControl } from "../ags-auto-spins-count-radio-control";

export class AgsAutoSpinsCountRadioControlFactory extends AutoSpinsCountRadioControlFactory {
    public build(layer: Layers) {
        const data = this.getButtonsAndLabels(layer, "autoplay");
        return [new AgsAutoSpinsCountRadioControl(data.buttons, data.labels, layer.getFlexiButton("autoplay_radio_left"), layer.getFlexiButton("autoplay_radio_right"))];
    }
}
